import { render, staticRenderFns } from "./modalBeneficio.vue?vue&type=template&id=5ad72370&scoped=true"
import script from "./modalBeneficio.vue?vue&type=script&lang=js"
export * from "./modalBeneficio.vue?vue&type=script&lang=js"
import style0 from "./modalBeneficio.vue?vue&type=style&index=0&id=5ad72370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad72370",
  null
  
)

export default component.exports